import { reactive } from 'vue';
import http from '@/services/http';

/**
 * Nama tingkat bisa berbeda per kejuaraan. Di sistem hanya ada tiga tingkat
 * (Prestasi, Pemasalan, Khusus/Invitasi), tetapi THB kejuaraan kadang
 * menamainya lain — mis. Dispora Cup menyebut Prestasi "Khusus Kota Bogor"
 * dan Pemasalan "Open". Namanya disimpan di kolom tournaments.label_tingkat.
 */
export function labelTingkat(tingkat, turnamen) {
  if (!tingkat) return '';
  const khusus = turnamen?.label_tingkat?.[tingkat];
  if (khusus) return khusus;
  return tingkat === 'Khusus' ? 'Invitasi' : tingkat;
}

/** "Tanding Prestasi" -> "Tanding Khusus Kota Bogor" bila kejuaraannya punya nama sendiri. */
export function gantiTingkatDiNama(nama, turnamen) {
  const label = turnamen?.label_tingkat;
  if (!nama || !label) return nama || '';
  // Tingkat Khusus tertulis "Invitasi" di nama kategori.
  return String(nama).replace(/\b(Prestasi|Pemasalan|Invitasi)\b/g, (t) => label[t === 'Invitasi' ? 'Khusus' : t] || t);
}

/*
 * Penyimpanan label per turnamen untuk halaman yang hanya tahu id turnamen
 * (daftar atlet, tagihan, status pendaftaran). Dimuat sekali per sesi.
 */
const labelPerTurnamen = reactive({});
let sedangMuat = null;

export function muatLabelTingkat() {
  if (!sedangMuat) {
    sedangMuat = http.get('/tournaments/all', { diamDiam: true })
      .then(({ data }) => {
        (Array.isArray(data) ? data : data?.data || []).forEach((t) => {
          if (t.label_tingkat) labelPerTurnamen[t.id] = t.label_tingkat;
        });
      })
      .catch(() => { sedangMuat = null; });
  }
  return sedangMuat;
}

/** Seperti gantiTingkatDiNama, tetapi cukup dengan id turnamen. */
export function gantiTingkatUntuk(nama, tournamentId) {
  const label = tournamentId ? labelPerTurnamen[tournamentId] : null;
  return label ? gantiTingkatDiNama(nama, { label_tingkat: label }) : (nama || '');
}
